import {
  isNativeAppMajorVersionBelow,
  isReactNativeApp,
  isReactNativeIos,
} from '@mobi/web-native-comms/web'

export const isNativeBraintreeAvailable = () => {
  const iosAppVersionRequiedForBraintree = 274

  if (!isReactNativeApp) return false

  if (isReactNativeIos && isNativeAppMajorVersionBelow(iosAppVersionRequiedForBraintree))
    return false

  return true
}
